import { css } from "@emotion/react";
import { useState } from "react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useAccountID } from "../store/account";
import { showPaidModal } from "../store/ui";

const modalStyles = {
    content: {
        top: "10%",
        left: "35%",
        right: "35%",
        bottom: "auto"
        //marginRight: "-50%",
        //transform: "translate(-50%, -50%)"
    }
};
export default function PaidFeatureButton({ onClick, hasFeature, children, dialogContent }) {
    const dispatch = useDispatch();
    const openModal = event => {
        event.preventDefault();
        dispatch(showPaidModal(dialogContent));
    };
    const closeModal = () => setIsOpen(false);

    return children({ hasFeature, openModal, closeModal });
}
